import { linxFeature } from './linx-feature.state';

export * from './linx-feature.actions';
export * from './linx-feature.state';

export const { selectEntityModalData } = linxFeature;
